__turbopack_context__.v({
  "checked": "CheckList-module-scss-module__pcmELa__checked",
  "hide_input": "CheckList-module-scss-module__pcmELa__hide_input",
  "label": "CheckList-module-scss-module__pcmELa__label",
  "label_icon": "CheckList-module-scss-module__pcmELa__label_icon",
  "label_text": "CheckList-module-scss-module__pcmELa__label_text",
  "list_group": "CheckList-module-scss-module__pcmELa__list_group",
});
